<div class="mw-news">
  <div class="mw-news__header">
    <div class="mw-news__header-title text-body-1">
      <div>{{ 'CORE.NEWS.title' | translate }}</div>
      <a
        href="https://mworker.no/blogg/nyheter/ "
        target="_blank"
        class="mw-news__header-title-link text-caption"
      >
        {{ 'CORE.NEWS.see_all' | translate }}
      </a>
    </div>
    <div class="mw-news__header-actions">
      <button mat-icon-button (click)="onCloseMenu()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>
  <mat-divider></mat-divider>

  <div class="mw-news__content" mwPerfectScrollBar>
    <mat-nav-list>
      <div
        *ngFor="let item of news"
        class="mw-article"
        [class.mw-new-article]="item.showNewsSidebar"
      >
        <div
          *ngIf="item.featured"
          class="mw-article__image"
          [innerHtml]="item.image"
        ></div>
        <div class="text-caption">{{ item.date | date : 'dd.MM.yyyy' }}</div>
        <a
          [href]="item.link"
          [class.text-subtitle-1]="!item.featured"
          [class.text-headline-6]="item.featured"
          target="_blank"
        >
          {{ item.title }}
        </a>
        <div *ngIf="item.featured" class="mw-article__excerpt text-body-2">
          {{ item.excerpt }}
        </div>
      </div>
    </mat-nav-list>
  </div>
</div>
